module.exports = __webpack_public_path__ + "static/media/5.aad9e22f.png";